<template>
    <div class="home_block_6">
        <div class="listDiv">
            <div class="rowDiv">
                <div class="leftDiv fl">
                    <div class="row1">
                        <div class="fl">
                            <div class="s1 bg1 cl0">
                                <div class="conDiv">
                                    <img src="./image/wh-li-icon1.png">
                                    <small>Folk Culture</small>
                                    <span>民俗文化类</span>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="s2 bg2 clf">
                                <div class="conDiv">
                                    <img src="./image/wh-li-icon10.png">
                                    <small>Tourist Towns</small>
                                    <span>旅游小镇类</span>
                                    <div class="line"></div>
                                </div>
                            </div>
                        </div>
                        <div class="fr">
                            <div class="s3 bg1 cl0">
                                <div class="conDiv">
                                    <img src="./image/wh-li-icon2.png">
                                    <small>Cultural Theme Park</small>
                                    <span>文化主题公园</span>
                                    <div class="line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row2">
                        <div class="s4 bg3 clf">
                            <div class="conDiv">
                                <img src="./image/wh-li-icon5.png">
                                <small>Guzhen Gujie Gucun</small>
                                <span>古镇古街古村</span>
                                <div class="line"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rightDiv fl">
                    <div class="row3 clearfix">
                        <div class="row3fl fl">
                            <div class="s5 bg3 clf">
                                <div class="conDiv">
                                    <img src="./image/wh-li-icon3.png">
                                    <small>Ancient Facilities</small>
                                    <span>古代设施类</span>
                                    <div class="line"></div>
                                </div>
                            </div>
                        </div>
                        <div class="fr">
                            <div class="s6 bg1 cl0">
                                <div class="conDiv">
                                    <img src="./image/wh-li-icon4.png">
                                    <small>Religious Culture</small>
                                    <span>宗教文化类</span>
                                    <div class="line"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row4 clearfix">
                        <div class="row4fl fl">
                            <div class="s7 bg4 clf">
                                <div class="conDiv">
                                    <img src="./image/wh-li-icon6.png">
                                    <small>New Cultural Zones</small>
                                    <span>文化新区类</span>
                                    <div class="line"></div>
                                </div>
                            </div>
                        </div>
                        <div class="fr">
                            <div class="s8 bg2 clf">
                                <div class="conDiv">
                                    <img src="./image/wh-li-icon7.png">
                                    <small>Cultural Industrial Park</small>
                                    <span>文化产业园区</span>
                                    <div class="line"></div>
                                </div>
                            </div>
                            <div class="row5 clearfix">
                                <div class="s9 bg1 cl0 fl">
                                    <div class="conDiv">
                                        <img src="./image/wh-li-icon8.png">
                                        <small>Memorial Gardens</small>
                                        <span>纪念园类</span>
                                        <div class="line"></div>
                                    </div>
                                </div>
                                <div class="s10 bg1 cl0 fr">
                                    <div class="conDiv">
                                        <img src="./image/wh-li-icon9.png">
                                        <small>Celebrity Former Residence</small>
                                        <span>名人故居类</span>
                                        <div class="line"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EiHomeBlock6"
    }
</script>

<style scoped lang="scss">
    .home_block_6 {
        margin: 60px auto;
        width: 1600px;
        display: flex;
        justify-content: space-between;

        .fr {
            float: right;
        }

        .fl {
            float: left;
        }

        .listDiv {
            width: 100%;
            background: #4985a9;
            padding: 25px 0;
            margin-top: 23px;
        }

        .rowDiv {
            display: flex;
            justify-content: center;
        }

        .listDiv .leftDiv {
            width: 449px;
            margin-right: 12px;
        }

        .listDiv .rightDiv {
            width: 733px;
        }

        .listDiv .s1 {
            width: 183px;
            height: 177px;
            margin-bottom: 13px;
        }

        .listDiv .s2 {
            width: 183px;
            height: 178px;
        }

        .listDiv .s3 {
            width: 254px;
            height: 368px;
        }

        .listDiv .s4 {
            width: 449px;
            height: 177px;
            margin-top: 14px;
        }

        .listDiv .s5 {
            width: 423px;
            height: 178px;
            margin-bottom: 12px;
        }

        .listDiv .s6 {
            width: 297px;
            height: 178px;
            margin-bottom: 12px;
        }

        .listDiv .s7 {
            width: 256px;
            height: 368px;
        }

        .listDiv .s8 {
            width: 466px;
            height: 178px;
            margin-bottom: 12px;
        }

        .listDiv .s9 {
            width: 155px;
            height: 178px;
        }

        .listDiv .s10 {
            width: 297px;
            height: 178px;
        }

        .listDiv .bg1 {
            background: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .listDiv .bg2 {
            background: #ff6e61;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .listDiv .bg3 {
            background: #98bace;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .listDiv .bg4 {
            background: #ffb8b1;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .listDiv .conDiv {
            text-align: center;
        }

        .listDiv .conDiv small {
            font-size: 15.5px;
            display: block;
            font-weight: bold;
            margin: 5px 0 0;
        }

        .listDiv .conDiv span {
            font-size: 21px;
            display: block;
            font-weight: bold;
            letter-spacing: 1px;
        }

        .listDiv .cl0 {
            color: #000;
        }

        .listDiv .clf {
            color: #fff;
        }

        .listDiv .cl0 .line {
            width: 42px;
            height: 4px;
            background: #000;
            margin: 5px auto 10px;
        }

        .listDiv .clf .line {
            width: 42px;
            height: 4px;
            background: #fff;
            margin: 5px auto 10px;
        }

    }
    * img,span,a,div{
      user-select: none;
      -webkit-user-drag:none;
    }
</style>
